import ServiceGraphQL from 'src/service/gql-service';
import { getPaymentMethods } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const GetPaymentMethods = (variables) => {
  const params = {
    query: getPaymentMethods.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
